<template>
  <div class="pa-0" style="background-color: white !important;height: 1100px;overflow-y:hidden;overflow-x:hidden">
      <div style="display: flex;align-items: center;justify-content: center;position: relative;">
        <div  class="content" style="padding-top: 30px;" >
        </div>
      </div>
      <v-dialog
        persistent
        v-model="overlay"
      >
        <v-card style="background-color: white !important;" class="pa-4">
          <p style="color: black;">กรุณาเลือก Business Unit อีกครั้ง</p>
          <div>
            <v-select
              class="mb-4"
              v-model="Business"
              outlined
              dense
              label="Business Unit"
              hide-details
              :items="anotherAnswer"
            ></v-select>
          </div>
          <v-btn
            block
            color="success"
            :loading="loading"
            :disabled="!Business"
            @click="updateBusiness()"
          >
            ยืนยัน
          </v-btn>
        </v-card>
      </v-dialog>
      <div class="picStyle">
        <img :src="require('@/assets/logo Leader .png')" alt="" style="width: 245px;">
      </div>
      <div style="top: 130px;position: relative;" class="pa-4">
        <v-card height="400" color="#0010A3" style="border-radius: 15px !important;">
          <p class="opening-text">OPENING DAY</p>
          <div class="d-flex justify-space-around mb-4">
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">
                1
              </div>
                <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);" class="mt-0">
                  <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                    <img :src="dataStamp.boots1 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO686_20240801112055337929.jpg' : ''"
                    >
                  </v-avatar>
                </div>
                <div class="container-text">
                  <p style="" class="mb-0">
                    Morning
                  </p>
                  <p class="mb-0 top-text">
                    Session
                  </p>
                </div>
            </v-card>
            <v-card height="100" width="29%" style="border-radius: 15px !important;position: relative;">
              <div class="number">2</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots2 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO8710_20240801114935534919.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text2">
                <p style="text-align: center;" class="mb-0">
                  Strategic
                </p>
                <p class="mb-0 top-text">
                  Formulation
                </p>
              </div>
            </v-card>
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">3</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots3 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO3273_20240801115502875441.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text3">
                <p style="text-align: center;" class="mb-0">
                  Growth                </p>
                <p class="mb-0 top-text">
                  Mindset
                </p>
              </div>
            </v-card>
          </div>
          <div class="d-flex justify-space-around mb-4">
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">4</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots4 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO8332_20240801115616324286.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text4">
                <p style="text-align: center;" class="mb-0">
                  Organizational </p>
                <p class="mb-0 top-text">
                  Transformation
                </p>
              </div>
            </v-card>
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">5</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots5 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO5988_20240801115722217040.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text5">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0">
                  Enterprise Result </p>
                <p style="text-align: center;" class="mb-0 top-text">
                  Oriented
                </p>
              </div>
            </v-card>
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">6</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots6 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO7599_20240801115827439619.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text6">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0">
                  AI </p>
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  in Business
                </p>
              </div>
            </v-card>
          </div>
          <div class="d-flex justify-center">
            <v-card height="100" width="29%" style="border-radius: 15px !important;">
              <div class="number">7</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots7 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO8660_20240801115945158273.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text7">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0">
                  AI for Digital </p>
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  Marketing
                </p>
              </div>
            </v-card>
          </div>
          <!-- <v-row >
            <v-col cols="4" >
              <v-card height="100" width="110" style="border-radius: 15px !important;">

              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card height="100" width="110" style="border-radius: 15px !important;">

              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card height="100" width="110" style="border-radius: 15px !important;">

              </v-card>
            </v-col>
          </v-row> -->
        </v-card>
      </div>
      <div style="top: 125px;position: relative;" class="pa-4 pt-0">
        <v-card height="160" color="#FF8500" style="border-radius: 15px !important;">
          <p class="opening-text mb-3 pb-0">Common Privilege</p>
          <div class="d-flex justify-space-around mb-3">
            <v-card height="103" width="23%" style="border-radius: 15px !important;">
              <div class="number2">8</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots8 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO239_20240801120415886447.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text8">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0">
                  Online </p>
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  Workshop #1
                </p>
              </div>
            </v-card>
            <v-card height="103" width="23%" style="border-radius: 15px !important;">
              <div class="number2">9</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots9 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO623_20240801121155471946.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text8">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0">
                  Online </p>
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  Workshop #2
                </p>
              </div>
            </v-card>
            <v-card height="103" width="23%" style="border-radius: 15px !important;">
              <div class="number2">10</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots10 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO6555_20240801134948567625.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text8">
                <p style="text-align: center;" class="mb-0">
                  Online </p>
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  Workshop #3
                </p>
              </div>
            </v-card>
            <v-card height="103" width="23%" style="border-radius: 15px !important;">
              <div class="number2">11</div>
              <div style="text-align: center;position: absolute;top: 19px;left: 50%; transform: translateX(-50%);"  class="mt-0">
                <v-avatar style="box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots11 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO9019_20240801140157145369.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text8">
                <p style="text-align: center;text-wrap: nowrap;" class="mb-0 top-text">
                  Conference
                </p>
              </div>
            </v-card>
          </div>
        </v-card>
      </div>
      <div style="top: 125px;position: relative;background-color: white;" class="pa-4 pt-0 pb-0">
        <v-row class="pa-4 pt-0">
        <v-col cols="6" class="pl-0 pr-1">
            <v-card height="100" color="#0010A3" style="border-radius: 15px !important;">
              <div style="text-align: center;" class="pt-3">
                <v-avatar style="background-color: white !important;box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots12 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO8309_20240801135527860073.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text9">
                <p style="text-align: center;" class="mb-0">
                  Privilege </p>
                <p style="text-align: center;" class="mb-0 top-text">
                  by BU
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6" class="pr-0 pl-1">
            <v-card height="100" color="#FF8500" style="border-radius: 15px !important;">
              <div style="text-align: center;" class="pt-3">
                <v-avatar style="background-color: white !important;box-shadow: rgb(217, 217, 217) 0px 0px 7px 2px;">
                  <img :src="dataStamp.boots13 === 'True' ? 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/promotion/PROMO4487_20240801140501308231.jpg' : null"
                  >
                </v-avatar>
              </div>
              <div class="container-text9">
                <p style="text-align: center;" class="mb-0">
                  Closing </p>
                <p style="text-align: center;" class="mb-0 top-text">
                  Day
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div style="top: 123px;position: relative;text-align: center;" class="pa-4 pt-0">
        <v-btn width="250" color="#0010A3" dark @click="openScan">
          <v-icon class="mr-3">mdi-qrcode-scan</v-icon>SCAN NOW
        </v-btn>
      </div>
      <div style="top: 123px;position: relative;text-align: center;" class="pa-4 pt-0">
        <v-btn width="250" color="#FF8500" dark @click="$router.push('/').catch(()=>{})">
          <v-icon class="mr-3">mdi-home</v-icon>HOME
        </v-btn>
      </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Card',
  data () {
    return {
      anotherAnswer: ['SCG Smart Living Business', 'SCG Cement & Green Solution Business', 'SCG Distribution & Retail Business', 'SCG Decor Business'],
      dataStamp: null,
      nameSurname: null,
      major: null,
      subMajor: null,
      loading: false,
      customFeild: [],
      theme: null,
      success: false,
      screenHeight: window.innerWidth,
      stampData: null,
      overlay: false,
      Business: null,
      choiceGender: [
        {text: 'ชาย', value: 'male'},
        {text: 'หญิง', value: 'female'},
        {text: 'lgbt', value: 'lgbt'}
      ],
      form: {
        tel: '',
        bdDate: '',
        nameCustomer: ''
      },
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      profile_dev: {
        displayName: 'Tommm',
        pictureUrl:
          'https://sprofile.line-scdn.net/0hZRsyZnrmBX1eAC76d817Ai5QBhd9cVxvc2UYSW1QWk4xORZ4d24dHmMAC0ViZRJ-czQZTz4GXEVSE3IbQFb5SVkwW0pnMkQsc29Jnw',
        statusMessage: 'บังไค (Smug)',
        userId: 'Uce4206cc8a8aecce95875fa90b88347b'
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length > 11 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    }
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    let shopId = this.GET_SHOPID()
    if (shopId === 'U5bad3d6f53733785f626ceaeaad539f5') {
      this.sorce = this.$route.query.sorce
      this.theme = await this.GET_THEME()
      let data = {
        'lineUserId': this.newData.lineUserId
      }
      let result = await this.callBeTaskAPI('post', `/scg/checkCustomFeild/get`, data)
      if (result) {
        if (result[0].regisCustomFeild === null) {
        // alert('ddddd')
          this.overlay = true
          await this.getStampData()
        } else {
          await this.checkMember()
          await this.getStampData()
        }
      }

    // window.addEventListener('resize', this.updateScreenHeight)
    // console.log('newData2222', this.newData)
    }
  // if (this.newData.boots1 === 'True' && this.newData.boots2 === 'True' && this.newData.boots3 === 'True' && this.newData.boots4 === 'True' && this.newData.boots5 === 'True' && this.newData.boots6 === 'True') {
  //   this.success = true
  // }
  },
  beforeDestroy () {
  // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateScreenHeight)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_SHOPINFO', 'GET_THEME']),

    async checkNothaveCustomFeild () {

    },
    async getStampData () {
      let data = {
        'lineUserId': this.newData.lineUserId
      }
      let result = await this.callBeTaskAPI('post', `/scg/line/get`, data)
      this.dataStamp = result[0]
    },
    updateScreenHeight () {
      this.screenHeight = window.innerWidth
    },
    async checkMember () {
      setTimeout(() => {
      // this.showContent = true
      }, 1000)
      if (this.newData) {
      // this.checkIsMember = true
        if (this.sorce) {
          let form = {}
          form[this.sorce] = 'True'
          let res = await this.callBeTaskAPI('post', `/scg/edit/${this.newData.lineUserId}`, form)
          if (res.status === true) {
            Swal.fire({
              title: `คุณได้รับแสตมป์ และ 10 คะแนน`,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง'
            })
          }
        // await this.setProfile(this.profile)
        }
      } else {
        this.checkIsMember = false
      }
    },
    async updateBusiness () {
      try {
        this.loading = true
        let form = [{'customFeildName': 'Business Unit', 'value': this.Business}, {'customFeildName': 'Email'}]
        let param = {regisCustomFeild: null}
        param.regisCustomFeild = JSON.stringify(form)
        await this.callBeTaskAPI('post', `/scg/editUpdateMemberCustomFeild/${this.newData.memberId}`, param)
        this.loading = true
        this.overlay = false
        await this.checkMember()
        await this.getStampData()
      } catch (error) {

      }
    // form = [{"customFeildName": Business},{"customFeildName":"Email"}]
    // let param = {regisCustomFeild: null}
    // param.regisCustomFeild = JSON.stringify(form)
    // await this.callBeTaskAPI('post', `/scg/edit/up${this.newData.memberId}`, form)
    // this.overlay =
    },
    async openScan () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=U5bad3d6f53733785f626ceaeaad539f5`)
      if (Array.isArray(result.data)) {
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      }
      await this.$liff.init({
        liffId: this.$liffId
        // withLoginOnExternalBrowser: true
      }).then(async () => {
        await this.$liff.ready.then(async () => {
          if (process.env.NODE_ENV === 'development') {
          } else {
            if (!this.$liff.isLoggedIn()) {
              await this.$liff.login({redirectUri: window.location.href})
            } else {
              try {
                const result = await this.$liff.scanCodeV2()
                // document.querySelector('#result').innerHTML = result.value
                window.location.href = result.value
              } catch (error) {
                // alert(error)
                console.error('scanCodeV2', error)
              }
            }
          }
        })
      }).catch((err) => {
        // alert(err)
        // this.$router.push({ name: '404' })
        console.error(err.code, err.message)
      })
    }
  }
// async mounted() {
//     this.sorce = this.$route.query.sorce
//     this.profile = this.getLiffProfile()
//     this.checkMember()
//     console.log('a', this.sorce)
//   },
//   methods: {
//     ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
//     ...mapGetters('memberStore', ['GET_MEMBERINFO']),
//     ...mapActions('lineStore', ['setProfile']),

//     async checkMember () {
//       console.log('ddcheckMemberddd')
//       setTimeout(() => {
//         this.showContent = true
//       }, 1000)
//       console.log('this.newData', this.newData)
//       if (this.newData) {
//         this.checkIsMember = true
//         if (this.sorce) {
//           let form = {}
//           form[this.sorce] = 'True'
//           console.log('form', typeof this.profile.userId)
//           await this.callBeTaskAPI('post', `/memberSWU/edit/${this.profile.userId}`, form)
//           await this.setProfile(this.profile)
//         }
//       } else {
//         this.checkIsMember = false
//       }
//       console.log('ddcheckMemberddd')
//     }
//   }
}
</script>
<style scoped>
label {
  display: inline-block;
  margin: 10px;
}
.btnJa {
    background-color:white;
    padding: 3px 15px 3px 15px;border-radius: 10px;
    border: 2px solid #A5BECC;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);
    transition: all ease 0.3s;
}
.activeGender {
  background-color:#14C38E;
  padding: 3px 20px 3px 20px;border-radius: 10px;
  color: white;
  border: 2px solid #A5BECC;
  transform: translateY(-5px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
  transition: all ease 0.3s;
}
.v-input__slot {
  top: -16px;
}
.cardRegis {
    line-height: 35px;
    border-radius: 10px;
    box-shadow: 10px 10px 20px #e6e6e6;
  }
.justify {
  justify-content: center;
  display: flex;
}
.ddddd{
  background-color: rgb(242 197 188 / 80%);
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
}
.ccccc {
  background-color: rgb(227 227 227)
}
.content {
  position: absolute;
    top: -300px;
    width: 700px;
    height: 700px;
    background-color: #FF8500;
    border-radius: 60%;
    display: -webkit-box;
    display: -ms-flexbox;
    -ms-flex-pack: center;
    -ms-flex-align: center;
    /* align-items: center; */
  }
.picStyle {
  position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 20px;
}
.opening-text{
  text-align: center;
  color: white;
  padding-top: 10px;
  font-weight: bolder;
  font-size: 20px;
  letter-spacing: 2px;
}
.number {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0010A3;
  border: 2px solid #0010A3;
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
}
.number2 {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0010A3;
  border: 2px solid #FF8500;
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
}
.icon1 {
  position: absolute;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -10px;
  right: -40px;
}
.fontTopic {
  font-size: 13px;
  text-align: center;
}
.newline::before {
    content: "\A";
    white-space: pre; /* หรือใช้ pre-line */
}
.container-text {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #0010A3;
}
.container-text2 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #0010A3;
}
.container-text3 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #0010A3;
}
.container-text4 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #0010A3;
}
.container-text5 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #0010A3;
}
.container-text6 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #0010A3;
}
.container-text7 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #0010A3;
}
.container-text8 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: #FF8500;
}
.container-text9 {
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/StampCard.vue